import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	connect() {
		console.log('initThermometersForm');
		$('#thermometers').on('cocoon:after-insert', function (e, image) {
			$(image).css('display', 'block');
			$(image).fadeIn('slow');
		}).on('cocoon:before-remove', function (e, image) {
			$(this).data('remove-timeout', 1000);
			image.hide('slow');
		});
	}
}
